import * as _ from "lodash";
import { models, Report } from "powerbi-client";
import { PowerBIEmbed } from "powerbi-client-react";
import * as React from "react";
import { connect } from "react-redux";
import { I18n } from "react-redux-i18n";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { scwApi, scwClientAppApi } from "../../services/Api";
import { CategoryHierarchyDTO } from "../../services/models/CategoryHierarchyDTO";
import { IndicatorDTO } from "../../services/models/IndicatorDTO";
import Utils from "../../services/Utils";
import Heading from "../Heading";
import ButtonCustomGroup from "../ButtonCustomGroup";
import PanelBreadcrumb from "../panel/PanelBreadcrumb";
import PanelInfographics from "../panel/PanelInfographics";
import PanelMetadata from "../panel/PanelMetadata";
import PanelRelatedContent from "../panel/PanelRelatedContent";
import PanelSelectData from "../panel/PanelSelectData";
import PanelSelectGeographies from "../panel/PanelSelectGeographies";
import OutPutsInfo from "./OutPutsInfo";
import "./PageDataset.css";



type PageDatasetProps = RouteComponentProps<{}> & {
    locale: string[2],
    dataCategory: any,
    dataCategoriesGetOfIndicator: any,
    dataPowerBiEmbedInfo: any,
    dataIndicatorsGet: any,
    dataIndicatorsGetOfCategory: any,
    scwApiCategoriesGetOfIndicator: Function,
    scwApiIndicatorsGet: Function,
    scwApiIndicatorsGetOfCategory: Function,
    scwClientAppApiEmbedInfoGetEmbedInfo: Function,
}

type PageDatasetState = {
    category: CategoryHierarchyDTO | null,
    dataPowerBiEmbedInfo: any,
    locale: string[2],
    locationSearch: string,
    indicatorMain: IndicatorDTO | undefined,
    parentCategories: CategoryHierarchyDTO[],
    selectedIndicatorIdMain: number | null,
    selectedGeoEntityIDs: number[] | null,
    visual: any,
}

class PageDataset extends React.Component<PageDatasetProps, PageDatasetState> {

    readonly VISUAL_ID_BAR_CHART = "Bar Chart";
    readonly VISUAL_ID_BAR_CHART_WITH_MAP = "Bar Chart with Map";
    readonly VISUAL_ID_LINE_CHART_1_INDICATOR = "Line Chart";
    readonly VISUAL_ID_LINE_CHART_1_INDICATOR_WALES_ONLY = "Line Chart Wales Only";
    readonly VISUAL_ID_TABLE_1_INDICATOR = "Table";
    readonly VISUAL_ID_TABLE_1_INDICATOR_WALES_ONLY = "Table Wales Only";

    private renderCount: number = 0;
    report: Report | null = null;

    visuals: any[] = [
        {
            nameLanguageKey: "frontend_visual_name_bar_chart",
            reportIdName: this.VISUAL_ID_BAR_CHART,
            supportsSelectionScenario: 1
        },
        {
            nameLanguageKey: "frontend_visual_name_bar_chart_with_map",
            reportIdName: this.VISUAL_ID_BAR_CHART_WITH_MAP,
            supportsSelectionScenario: 1,
        },
        {
            nameLanguageKey: "frontend_visual_name_line_chart",
            reportIdName: this.VISUAL_ID_LINE_CHART_1_INDICATOR,
            supportsSelectionScenario: 1,
        },
        {
            nameLanguageKey: "frontend_visual_name_line_chart",
            reportIdName: this.VISUAL_ID_LINE_CHART_1_INDICATOR_WALES_ONLY,
            supportsSelectionScenario: 3,
        },
        {
            nameLanguageKey: "frontend_visual_name_table",
            reportIdName: this.VISUAL_ID_TABLE_1_INDICATOR,
            supportsSelectionScenario: 1,
        },
        {
            nameLanguageKey: "frontend_visual_name_table",
            reportIdName: this.VISUAL_ID_TABLE_1_INDICATOR_WALES_ONLY,
            supportsSelectionScenario: 3,
        },
    ];

    constructor(props: Readonly<PageDatasetProps>) {
        super(props);

        this.state = {
            category: null,
            dataPowerBiEmbedInfo: null,
            locale: props.locale,
            locationSearch: "",
            indicatorMain: undefined,
            parentCategories: [],
            selectedIndicatorIdMain: null,
            selectedGeoEntityIDs: null,
            visual: this.visuals[0],
        };
    } // constructor

    static getDerivedStateFromProps(nextProps: Readonly<PageDatasetProps>,
        prevState: PageDatasetState): Partial<PageDatasetState> | null {

        // ?i=:ids <- indicatorId
        // ?c=:cid&p=:pids <- category & parentIds

        // Get/refresh token for PowerBI visual
        var loScwClientAppApiEmbedInfoGetEmbedInfoObject =
            nextProps.dataPowerBiEmbedInfo(prevState.visual.reportIdName);

        if (
            !loScwClientAppApiEmbedInfoGetEmbedInfoObject.isSuccess
            && !loScwClientAppApiEmbedInfoGetEmbedInfoObject.isLoading
        )
            nextProps.scwClientAppApiEmbedInfoGetEmbedInfo(prevState.visual.reportIdName);

        // Read location's parameters to get category and its parents
        const loParams = new URLSearchParams(nextProps.location.search);

        const lsCategoryId = loParams.get("c");
        const lsParentCategories = loParams.get("p");
        const lsIndicators = loParams.get("i");

        let loCategory: CategoryHierarchyDTO | null;
        let loParentCategories: CategoryHierarchyDTO[];

        let nextStateSelectedIndicatorIdMain = prevState.selectedIndicatorIdMain;

        // load parent categories
        if (lsParentCategories)
            loParentCategories = Utils.getParentCategoriesByIds(lsParentCategories as string, nextProps.dataCategory.data);
        else
            loParentCategories = [];

        // load category
        if (loParentCategories.length > 0)
            loCategory = Utils.getCategoryById(lsCategoryId, loParentCategories[loParentCategories.length - 1].children);
        else
            loCategory = Utils.getCategoryById(lsCategoryId, nextProps.dataCategory.data);

        if (!_.isNil(loCategory)) {
            const loApiObjectIndicatorsOfCategory =
                nextProps.dataIndicatorsGetOfCategory(
                    nextProps.locale,
                    (loCategory as CategoryHierarchyDTO).categoryID
                );
            if (
                !loApiObjectIndicatorsOfCategory.isSuccess
                && !loApiObjectIndicatorsOfCategory.isLoading
            )
                nextProps.scwApiIndicatorsGetOfCategory(
                    nextProps.locale,
                    (loCategory as CategoryHierarchyDTO).categoryID
                );

            const liIndicatorIdArr = (lsIndicators) ? lsIndicators.split(",").map(asIndicatorId => parseInt(asIndicatorId)) : [];

            // Initialise selected indicator(s), if has/have not been initialised or provided via url indicator id is different
            if (
                _.isNil(nextStateSelectedIndicatorIdMain)
                || (
                    (liIndicatorIdArr.length > 0)
                    && (nextStateSelectedIndicatorIdMain !== liIndicatorIdArr[0])
                )
            ) {
                // Try initialise from url parameter
                if (liIndicatorIdArr.length > 0)
                    nextStateSelectedIndicatorIdMain = liIndicatorIdArr[0];

                // If no indicators provided via url, choose first of category
                if (
                    (_.isNil(nextStateSelectedIndicatorIdMain))
                    && !_.isNil(loApiObjectIndicatorsOfCategory.data)
                    && (loApiObjectIndicatorsOfCategory.data.length > 0)
                )
                    nextStateSelectedIndicatorIdMain =
                        (loApiObjectIndicatorsOfCategory.data[0] as IndicatorDTO).indicatorID;
            }
        }

        // Consider case when only indicator has been provided - information about owning category needs to be loaded
        if (!lsCategoryId && lsIndicators) {
            const liIndicatorIdArr = lsIndicators.split(",").map(asIndicatorId => parseInt(asIndicatorId));
            if (liIndicatorIdArr.length > 0) {
                const loApiObjectCategoriesGetOfIndicator =
                    nextProps.dataCategoriesGetOfIndicator(nextProps.locale, liIndicatorIdArr[0]);

                if (
                    !loApiObjectCategoriesGetOfIndicator.isSuccess && !loApiObjectCategoriesGetOfIndicator.isLoading
                )
                    nextProps.scwApiCategoriesGetOfIndicator(nextProps.locale, liIndicatorIdArr[0]);
                else if (
                    !_.isNil(loApiObjectCategoriesGetOfIndicator.data) &&
                    loApiObjectCategoriesGetOfIndicator.data.length > 0
                ) {
                    const loCategoryHierarchyURLParams =
                        Utils.getCategoriesHierarchyURLParams(loApiObjectCategoriesGetOfIndicator.data[0]);

                    nextProps.history.push(`${nextProps.location.pathname}?c=${loCategoryHierarchyURLParams.categoryId}&p=${loCategoryHierarchyURLParams.parentCategoryIds}&i=${lsIndicators}`);
                };

            }
        }

        let nextStateIndicatorMain = null;
        // Ensure selected indicators' data is loaded (if selected indicator(s) has/have been initialised)
        if (!_.isNil(nextStateSelectedIndicatorIdMain)) {

            // Reload information about indication; important to refresh when language has changed
            const loApiObject = nextProps.dataIndicatorsGet(nextProps.locale, nextStateSelectedIndicatorIdMain);

            if (loApiObject.isSuccess)
                nextStateIndicatorMain = loApiObject.data[0];
            else if (!loApiObject.isLoading)
                nextProps.scwApiIndicatorsGet(nextProps.locale, nextStateSelectedIndicatorIdMain);
        }

        return {
            category: loCategory,
            dataPowerBiEmbedInfo: loScwClientAppApiEmbedInfoGetEmbedInfoObject,
            indicatorMain: nextStateIndicatorMain,
            locale: nextProps.locale,
            locationSearch: nextProps.location.search,
            parentCategories: loParentCategories,
            selectedIndicatorIdMain: nextStateSelectedIndicatorIdMain,
        };
    } // getDerivedStateFromProps


    getSelectionScenario() {
        //case two indicators
        if (this.state.indicatorMain?.isNationalOnly === false || _.isNil(this.state.indicatorMain)) {
            return 1;
        }
        else {
            return 3;
        }
    }

    onButtonGroupVisualsGetCaption(aoObject: any) {
        return I18n.t(aoObject.nameLanguageKey);
    } // onButtonGroupVisualsGetCaption

    onButtonGroupVisualsSelected(aoObject: any) {
        this.setState({
            visual: aoObject,
        });
    } // onButtonGroupVisualsSelected

    onSelectGeographiesSelectionChanged(aiGeoEntityIDs: number[]) {
        // console.log("(PageDataset.onSelectGeographiesSelectionChanged)", aiGeoEntityIDs);

        this.setState(
            {
                selectedGeoEntityIDs: aiGeoEntityIDs
            }
        );
    } // onSelectGeographiesSelectionChanged

    onPanelSelectDataSelected(aoIndicator: any) {
        // console.log("(PageDataset.onPanelSelectDataSelected)", aoIndicator);

        const loParams = new URLSearchParams(this.props.location.search);

        const lsCategoryId = loParams.get("c");
        const lsParentCategories = loParams.get("p");
        const lsIndicators = loParams.get("i");

        if (lsIndicators != aoIndicator.indicatorID)
            this.props.history.push(`${this.props.location.pathname}?c=${lsCategoryId}&p=${lsParentCategories}&i=${aoIndicator.indicatorID}`);
    } // onPanelSelectDataSelected

    render() {
        if (_.isNil(this.state.category))
            return null;

        //console.log(this.state);
        //console.log(this.getSelectionScenario());
        // Check if selected visual supports number of selected indicators or we have national only indicators and switch to alternative if not
        if (
            !_.isNil(this.state.visual.supportsSelectionScenario) &&
            (this.state.visual.supportsSelectionScenario !== this.getSelectionScenario())
        ) {
            let lsAlternativeReportIdName: string | null = null;
            switch (this.state.visual.reportIdName) {
                case this.VISUAL_ID_BAR_CHART_WITH_MAP:
                    lsAlternativeReportIdName = this.VISUAL_ID_BAR_CHART;
                    break;
                case this.VISUAL_ID_BAR_CHART:
                    if (this.getSelectionScenario() === 3) {
                        lsAlternativeReportIdName = this.VISUAL_ID_LINE_CHART_1_INDICATOR_WALES_ONLY;
                    }
                    break;

                case this.VISUAL_ID_LINE_CHART_1_INDICATOR:
                    if (this.getSelectionScenario() === 3) {
                        lsAlternativeReportIdName = this.VISUAL_ID_LINE_CHART_1_INDICATOR_WALES_ONLY;
                    }
                    break;

                case this.VISUAL_ID_LINE_CHART_1_INDICATOR_WALES_ONLY:
                    if (this.getSelectionScenario() === 1) {
                        lsAlternativeReportIdName = this.VISUAL_ID_LINE_CHART_1_INDICATOR;
                    }
                    break;

                case this.VISUAL_ID_TABLE_1_INDICATOR:
                    if (this.getSelectionScenario() === 3) {
                        lsAlternativeReportIdName = this.VISUAL_ID_TABLE_1_INDICATOR_WALES_ONLY;
                    }

                    break;
                case this.VISUAL_ID_TABLE_1_INDICATOR_WALES_ONLY:
                    if (this.getSelectionScenario() === 1) {
                        lsAlternativeReportIdName = this.VISUAL_ID_TABLE_1_INDICATOR;
                    }
                    break;

                default:
                    ;
            };

            if (!_.isNil(lsAlternativeReportIdName)) {
                const loAlternativeVisual = _.find(this.visuals, v => (v.reportIdName === lsAlternativeReportIdName));
                if (!_.isNil(loAlternativeVisual)) {
                    this.setState({
                        visual: loAlternativeVisual
                    });

                    return null;
                }
            }

        }

        // Filter available visuals(buttons) based on number of selected indicators - see l64
        const loVisuals =
            _.filter(this.visuals,
                v => {
                    return (
                        (_.isNull(v.supportsSelectionScenario)
                            || (v.supportsSelectionScenario === this.getSelectionScenario()))
                    );
                }
            );
        //console.log(loVisuals);
        this.renderCount += 1;

        return (
            <div className="page-dataset">
                <PanelBreadcrumb className="page-dataset-breadcrumb" />

                <Heading
                    align="left"
                    className="page-dataset-heading"
                    description={this.state.category.categoryDescription}
                    title={this.state.category.categoryName}
                />

                <PanelInfographics groupId={`category_${this.state.category.categoryID}`} />

                <div className="page-dataset-section">

                    <PanelSelectGeographies
                        onSelectionChanged={(aiGeoEntityIDs: number[]) => this.onSelectGeographiesSelectionChanged(aiGeoEntityIDs)}
                        selectedGeoEntityIDs={this.state.selectedGeoEntityIDs}
                    />
                    {
                        (!_.isNil(this.state.selectedIndicatorIdMain))
                        && (!_.isNil(this.state.indicatorMain))
                        && (
                            <PanelSelectData
                                allowSearch={false}
                                categoryId={(this.state.category as CategoryHierarchyDTO).categoryID}
                                indicator={this.state.indicatorMain}
                                onSelected={(aoIndicator: any) => this.onPanelSelectDataSelected(aoIndicator)}
                            />
                        )
                    }

                    <div className="splitter wide"></div>
                    {
                        (
                            !_.isNil(this.state.dataPowerBiEmbedInfo)
                            && this.state.dataPowerBiEmbedInfo.isSuccess
                            && !_.isNil(this.state.indicatorMain)
                            && (!_.isNil(this.state.selectedGeoEntityIDs) && this.state.selectedGeoEntityIDs.length > 0)
                            && (
                                <div>
                                    <div className="page-dataset-visual-selection-container">
                                        <OutPutsInfo />
                                        <ButtonCustomGroup
                                            className="page-dataset-visual-selection"
                                            objects={loVisuals}
                                            onGetCaption={(aoObject: any) => this.onButtonGroupVisualsGetCaption(aoObject)}
                                            onSelected={(aoObject: any) => this.onButtonGroupVisualsSelected(aoObject)}
                                            selectedObject={this.state.visual}
                                        />
                                    </div>

                                    <PowerBIEmbed
                                        cssClassName={"powerbi-embed-container"}

                                        embedConfig={{
                                            type: "report",   // Supported types: report, dashboard, tile, visual and qna
                                            id: this.state.dataPowerBiEmbedInfo.data.EmbedReport[0].ReportId,
                                            embedUrl: this.state.dataPowerBiEmbedInfo.data.EmbedReport[0].EmbedUrl,
                                            accessToken: this.state.dataPowerBiEmbedInfo.data.EmbedToken.Token,
                                            tokenType: models.TokenType.Embed,
                                            filters: [
                                                {
                                                    $schema: "http://powerbi.com/product/schema#basic",
                                                    target: {
                                                        table: "Indicators",
                                                        column: "IndicatorID"
                                                    },
                                                    operator: "In",
                                                    values: _.isNil(this.state.indicatorMain) ? [] : [this.state.indicatorMain.indicatorID],
                                                    filterType: 1,
                                                    requireSingleSelection: false,
                                                    displaySettings: {
                                                        isLockedInViewMode: true,
                                                        isHiddenInViewMode: true,
                                                    }
                                                },
                                                {
                                                    $schema: "http://powerbi.com/product/schema#basic",
                                                    target: {
                                                        table: "Indicators",
                                                        column: "Languages.Code.Name"
                                                    },
                                                    operator: "In",
                                                    values: [this.props.locale],
                                                    filterType: 1,
                                                    requireSingleSelection: false,
                                                    displaySettings: {
                                                        isLockedInViewMode: true,
                                                        isHiddenInViewMode: true,
                                                    }
                                                },
                                                {
                                                    $schema: "http://powerbi.com/product/schema#basic",
                                                    target: {
                                                        table: "Geographies",
                                                        column: "GeoEntityID"
                                                    },
                                                    operator: "In",
                                                    values: this.state.selectedGeoEntityIDs.concat([30] /* Wales */),
                                                    filterType: 1,
                                                    requireSingleSelection: false,
                                                    displaySettings: {
                                                        isLockedInViewMode: true,
                                                        isHiddenInViewMode: true,
                                                    }
                                                },
                                                {
                                                    $schema: "http://powerbi.com/product/schema#basic",
                                                    target: {
                                                        table: "Geographies",
                                                        column: "Languages.Code.GeoEntityName"
                                                    },
                                                    operator: "In",
                                                    values: [this.props.locale],
                                                    filterType: 1,
                                                    requireSingleSelection: false,
                                                    displaySettings: {
                                                        isLockedInViewMode: true,
                                                        isHiddenInViewMode: true,
                                                    }
                                                }
                                            ],
                                            settings: {
                                                filterPaneEnabled: false,
                                                navContentPaneEnabled: false,
                                                panes: {
                                                    filters: {
                                                        expanded: false,
                                                        visible: false
                                                    }
                                                },
                                                // background: models.BackgroundType.Transparent,
                                            }
                                        }}

                                        getEmbeddedComponent={
                                            (embeddedReport: any) => {
                                                this.report = embeddedReport as Report;

                                                this.report.on("loaded", function () {
                                                    // console.log('Report loaded')
                                                });
                                                this.report.on("rendered", function () {
                                                    // console.log('Report rendered');
                                                });
                                                this.report.on("loaded", function (event) {
                                                    ///console.log(event.detail);
                                                });
                                            }
                                        }

                                        key={this.renderCount}
                                    />
                                </div>
                            )
                        )
                    }
                    <div className="splitter wide"></div>

                    <PanelRelatedContent categoryID={this.state.category.categoryID} />
                    {
                        !_.isNil(this.state.indicatorMain) && (
                            <div>
                                <div className="splitter"></div>

                                <PanelMetadata indicatorID={(this.state.indicatorMain as IndicatorDTO).indicatorID} />
                            </div>
                        )
                    }
                </div>
            </div>
        );
    } // render
};

// Link with Redux store

const mapStateToProps =
    (state: any) => (
        {
            locale: state.i18n.locale,
            dataCategory: scwApi.endpoints.categoriesGetHierarchyAll.select(state.i18n.locale)(state),
            dataCategoriesGetOfIndicator: (languageCode: string, indicatorId: number) => scwApi.endpoints.categoriesGetOfIndicator.select({ "languageCode": languageCode, "indicatorId": indicatorId })(state),
            dataIndicatorsGet: (languageCode: string, id: number) => scwApi.endpoints.indicatorsGet.select({ "languageCode": languageCode, "id": id })(state),
            dataIndicatorsGetOfCategory: (languageCode: string, categoryId: number) => scwApi.endpoints.indicatorsGetOfCategory.select({ "languageCode": languageCode, "categoryId": categoryId })(state),
            dataPowerBiEmbedInfo: (reportIdName: string) => scwClientAppApi.endpoints.embedInfoGetEmbedInfo.select(reportIdName)(state),
        }
    );

const mapDispatchToProps =
    (dispatch: Function) => {
        return {
            scwApiCategoriesGetOfIndicator: (languageCode: string, indicatorId: number) => dispatch(scwApi.endpoints.categoriesGetOfIndicator.initiate({ languageCode: languageCode, indicatorId: indicatorId })),
            scwApiIndicatorsGet: (languageCode: string, id: number) => dispatch(scwApi.endpoints.indicatorsGet.initiate({ languageCode: languageCode, id: id })),
            scwApiIndicatorsGetOfCategory: (languageCode: string, categoryId: number) => dispatch(scwApi.endpoints.indicatorsGetOfCategory.initiate({ languageCode: languageCode, categoryId: categoryId })),
            scwClientAppApiEmbedInfoGetEmbedInfo: (reportIdName: string) => dispatch(scwClientAppApi.endpoints.embedInfoGetEmbedInfo.initiate(reportIdName)),
        }
    };

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PageDataset));